export enum COUNTER_APP {
  CIVIC_SERVICE = 'civic-service',
}
